module.exports = __webpack_public_path__ + "media/components/images/flows/4-9e65e2624ecd95e954fad3e312d16e69.svg";